const GalleryData = [
  {
    img: "images/newimages/6.jpg",
    title: "Gallery two",
  },
  {
    img: "images/myimages/1.webp",
    title: "Gallery One",
  },
  {
    img: "images/myimages/222.jpg",
    title: "Gallery two",
  },
  {
    img: "images/rooms/1.jpg",
    title: "Gallery three",
  },
  {
    img: "images/rooms/2.jpg",
    title: "Gallery Four",
  },
  {
    img: "images/rooms/3.jpg",
    title: "Gallery Five",
  },


  {
    img: "images/newimages/3.jpg",
    title: "Gallery two",
  },
  {
    img: "images/newimages/15.jpg",
    title: "Gallery two",
  },
  {
    img: "images/newimages/7.jpg",
    title: "Gallery Twelve",
  },
  {
    img: "images/newimages/4.jpg",
    title: "Gallery two",
  },

  {
    img: "images/myimages/2.jpg",
    title: "Gallery Two",
  },
  {
    img: "images/myimages/3.jpg",
    title: "Gallery Three",
  },
  {
    img: "images/myimages/4.jpg",
    title: "Gallery Four",
  },
  {
    img: "images/myimages/5.jpg",
    title: "Gallery Five",
  },
  {
    img: "images/myimages/6.jpg",
    title: "Gallery Six",
  },
  {
    img: "images/myimages/7.jpg",
    title: "Gallery Seven",
  },

  {
    img: "images/newimages/2.jpg",
    title: "Gallery two",
  },
  {
    img: "images/myimages/8.jpg",
    title: "Gallery Eight",
  },
  {
    img: "images/myimages/9.jpg",
    title: "Gallery Nine",
  },
  {
    img: "images/myimages/10.jpg",
    title: "Gallery Ten",
  },
  {
    img: "images/myimages/11.jpg",
    title: "Gallery Eleven",
  },
  {
    img: "images/myimages/12.jpg",
    title: "Gallery Twelve",
  },

]

export default GalleryData
